const appUserRoles = {
  ContentManager: "ContentManager",
  MarketAdmin: "MarketAdmin",
  ApplicationManager: "ApplicationManager",
  Admin: "Admin",
  FleetManager: "FleetManager",
  Reporter: "Reporter"
};

export default appUserRoles;
